/**
 * The categorical colours: a study's groups, a board card's segments. One colour per entity, the
 * same in a table's headers and on every chart, so a reader follows it from one to the other. Cool
 * hues only: green and red say a clinician's verdict, amber a technical surface, and none of them is
 * what a group is.
 *
 * Validated, not picked (dataviz `validate_palette.js`, light, on white): neighbours stay apart under
 * protanopia and deuteranopia (ΔE ≥ 8.1, ≥ 17.9 over the first six) and for full colour vision
 * (≥ 16.1), every slot clears 3:1, and the first three — a study's usual groups — are apart pairwise.
 * Six for a study's groups, eight for a card's top values; past them a colour is slate rather than a
 * repeat of the first. Eight cool hues cannot all be apart pairwise: the legend says which is which.
 */
export const GROUP_COLORS = [
  "#1752B7",
  "#04A3AA",
  "#4377FF",
  "#644386",
  "#888DD8",
  "#6C39DD",
  "#0975A2",
  "#8763D6",
];

const OVERFLOW = "#64748B";

export const groupColor = (index: number) => GROUP_COLORS[index] ?? OVERFLOW;
